/**
 * Pure helpers to label a device's CPU architecture for logs, e.g.
 * "mac-arm64", "mac-x64", "windows-x64". Inputs come from two sources:
 *  - Node/Electron: process.arch ("arm64" | "x64" | "ia32" | …)
 *  - Browser: UA-Client-Hints high-entropy { architecture, bitness }
 * Both are normalised here so a Datadog query can slice by exact silicon.
 */

export function normalizeArch(architecture?: string | null, bitness?: string | null): string {
  const a = (architecture || "").toLowerCase()
  const b = (bitness ?? "").toString()
  if (!a) return "unknown"
  if (a.includes("arm") || a.includes("aarch")) return b === "32" ? "arm32" : "arm64"
  if (a.includes("amd64") || a.includes("x86_64") || a === "x64") return "x64"
  if (a.includes("ia32") || a.includes("x86") || a === "x86") return b === "64" ? "x64" : "x86"
  return a
}

export function deviceArchLabel(
  platform?: string | null,
  architecture?: string | null,
  bitness?: string | null
): string {
  const p = (platform || "unknown").toLowerCase()
  const a = normalizeArch(architecture, bitness)
  return `${p}-${a}`
}
